export default {

  getVariableById: (state) => (id) => {
    return state.variableList.filter(variable => variable.id === id)[0]
  }
}